import * as React from 'react'
import { isEmpty } from 'lodash'
import styled from 'styled-components'

import { Action } from '~/components'
import { SelectedFilterTags } from '~/components/filters'
import { useFilters } from '~/hooks'
import { useFiltersState } from '~/hooks/use-filters-state'
import { images } from '~/utils/constants'

const StyledEmptyStateContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.cozy * 2}px;
  text-align: center;
  width: ${props => props.theme.spacing.cozy * 48.25}px;
`

const StyledSelectedFilterTags = styled(SelectedFilterTags)`
  justify-content: center;
`

export function EmptyStateContent() {
  const { selectedTags } = useFilters()

  const { clearFilters } = useFiltersState()

  const hasSelectedTags = !isEmpty(selectedTags)

  return (
    <StyledEmptyStateContent>
      <div>
        <img src={images.ILLUSTRATION_ONLINE_SHOP} />
      </div>
      <h4 className="text-xl font-bold">No se encontraron productos</h4>
      <p>No se encontraron productos que coincidan con tu búsqueda. Intenta con menos filtros.</p>
      {hasSelectedTags && (
        <>
          <StyledSelectedFilterTags />
          <div>
            <Action $color="info" onClick={() => clearFilters()}>
              Limpiar todos los filtros
            </Action>
          </div>
        </>
      )}
    </StyledEmptyStateContent>
  )
}
